import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const RoeyAdminPage = () => {
  const [password, setPassword] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [token, setToken] = useState('');
  const [tournaments, setTournaments] = useState([]);
  const [users, setUsers] = useState([]);
  const [message, setMessage] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage('מתחבר...');
    
    try {
      const response = await axios.post(`${BACKEND_URL}/api/auth/login`, {
        email: 'shafirroy@icloud.com',
        password: password
      });
      
      setToken(response.data.access_token);
      setIsLoggedIn(true);
      setMessage('התחברת בהצלחה!');
      loadData(response.data.access_token);
    } catch (error) {
      setMessage(`שגיאה: ${error.response?.data?.detail || error.message}`);
    }
  };

  const loadData = async (authToken) => {
    try {
      const [tournamentsRes, usersRes] = await Promise.all([
        axios.get(`${BACKEND_URL}/api/tournaments`),
        axios.get(`${BACKEND_URL}/api/admin/users`, {
          headers: { Authorization: `Bearer ${authToken}` }
        })
      ]);
      setTournaments(tournamentsRes.data || []);
      setUsers(usersRes.data || []);
      setMessage('נתונים נטענו בהצלחה!');
    } catch (error) {
      setMessage(`שגיאה בטעינת נתונים: ${error.message}`);
    }
  };

  const handleGenerateDraw = async (tournamentId, tournamentName) => {
    if (!window.confirm(`האם לבצע הגרלה עבור "${tournamentName}"?`)) return;
    
    setMessage('מבצע הגרלה...');
    try {
      const response = await axios.post(
        `${BACKEND_URL}/api/tournaments/${tournamentId}/generate-draw`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessage(`✅ הצלחה! נוצרו ${response.data.matches_count} משחקים`);
      loadData(token);
    } catch (error) {
      setMessage(`❌ שגיאה: ${error.response?.data?.detail || error.message}`);
    }
  };

  const handleResetTournament = async (tournamentId, tournamentName) => {
    if (!window.confirm(`⚠️ האם לאפס את "${tournamentName}"? כל המשחקים ימחקו!`)) return;
    
    setMessage('מאפס טורניר...');
    try {
      const response = await axios.post(
        `${BACKEND_URL}/api/admin/tournaments/${tournamentId}/reset`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessage(`✅ הצלחה! נמחקו ${response.data.matches_deleted} משחקים`);
      loadData(token);
    } catch (error) {
      setMessage(`❌ שגיאה: ${error.response?.data?.detail || error.message}`);
    }
  };

  const handleDeleteTournament = async (tournamentId, tournamentName) => {
    if (!window.confirm(`⚠️⚠️ האם למחוק לצמיתות את "${tournamentName}"?`)) return;
    
    setMessage('מוחק תחרות...');
    try {
      await axios.delete(
        `${BACKEND_URL}/api/admin/tournaments/${tournamentId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessage(`✅ התחרות "${tournamentName}" נמחקה`);
      loadData(token);
    } catch (error) {
      setMessage(`❌ שגיאה: ${error.response?.data?.detail || error.message}`);
    }
  };

  const handleDeleteUser = async (userId, userName) => {
    if (!window.confirm(`⚠️⚠️ האם למחוק לצמיתות את "${userName}"?`)) return;
    
    setMessage('מוחק משתמש...');
    try {
      await axios.delete(
        `${BACKEND_URL}/api/admin/users/${userId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessage(`✅ המשתמש "${userName}" נמחק`);
      loadData(token);
    } catch (error) {
      setMessage(`❌ שגיאה: ${error.response?.data?.detail || error.message}`);
    }
  };

  if (!isLoggedIn) {
    return (
      <div style={{ maxWidth: '400px', margin: '100px auto', padding: '30px', border: '2px solid #ccc', borderRadius: '10px', backgroundColor: '#f9f9f9' }}>
        <h1 style={{ textAlign: 'center', color: '#333' }}>🎛️ לוח בקרה - רועי שפיר</h1>
        <form onSubmit={handleLogin} style={{ marginTop: '30px' }}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>אימייל:</label>
            <input 
              type="text" 
              value="shafirroy@icloud.com" 
              readOnly 
              style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', backgroundColor: '#e9e9e9' }}
            />
          </div>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>סיסמה:</label>
            <input 
              type="password" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="הקלד סיסמה"
              style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '5px' }}
              autoFocus
            />
            <small style={{ color: '#666', marginTop: '5px', display: 'block' }}>הסיסמה: roey1234</small>
          </div>
          <button 
            type="submit"
            style={{ width: '100%', padding: '12px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px', fontSize: '16px', cursor: 'pointer', fontWeight: 'bold' }}
          >
            התחבר
          </button>
        </form>
        {message && (
          <div style={{ marginTop: '20px', padding: '10px', backgroundColor: message.includes('שגיאה') ? '#ffebee' : '#e8f5e9', borderRadius: '5px', textAlign: 'center' }}>
            {message}
          </div>
        )}
      </div>
    );
  }

  return (
    <div style={{ maxWidth: '1200px', margin: '20px auto', padding: '20px' }}>
      <h1 style={{ textAlign: 'center', color: '#333', marginBottom: '10px' }}>🎛️ לוח בקרה - רועי שפיר</h1>
      
      {message && (
        <div style={{ padding: '15px', backgroundColor: message.includes('❌') ? '#ffebee' : '#e8f5e9', borderRadius: '5px', marginBottom: '20px', textAlign: 'center', fontWeight: 'bold' }}>
          {message}
        </div>
      )}

      {/* ניהול תחרויות */}
      <div style={{ marginBottom: '40px', padding: '20px', border: '2px solid #ddd', borderRadius: '10px', backgroundColor: '#fff' }}>
        <h2 style={{ marginBottom: '20px', color: '#333' }}>🏆 תחרויות ({tournaments.length})</h2>
        {tournaments.length === 0 ? (
          <p>אין תחרויות</p>
        ) : (
          tournaments.map(t => (
            <div key={t.id} style={{ padding: '15px', marginBottom: '15px', border: '1px solid #ddd', borderRadius: '8px', backgroundColor: '#f9f9f9' }}>
              <div style={{ marginBottom: '10px' }}>
                <strong style={{ fontSize: '18px' }}>{t.name}</strong>
                <div style={{ color: '#666', fontSize: '14px', marginTop: '5px' }}>
                  {new Date(t.date).toLocaleDateString('he-IL')} • {t.registered_players?.length || 0}/{t.max_players} שחקנים
                </div>
              </div>
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                {t.registered_players?.length === t.max_players && (
                  <button 
                    onClick={() => handleGenerateDraw(t.id, t.name)}
                    style={{ padding: '8px 15px', backgroundColor: '#9C27B0', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}
                  >
                    🎲 הגרלה
                  </button>
                )}
                <button 
                  onClick={() => handleResetTournament(t.id, t.name)}
                  style={{ padding: '8px 15px', backgroundColor: '#FF9800', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
                >
                  🔄 איפוס
                </button>
                <button 
                  onClick={() => handleDeleteTournament(t.id, t.name)}
                  style={{ padding: '8px 15px', backgroundColor: '#f44336', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
                >
                  🗑️ מחק
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      {/* ניהול משתמשים */}
      <div style={{ padding: '20px', border: '2px solid #ddd', borderRadius: '10px', backgroundColor: '#fff' }}>
        <h2 style={{ marginBottom: '20px', color: '#333' }}>👥 משתמשים ({users.length})</h2>
        {users.length === 0 ? (
          <p>אין משתמשים</p>
        ) : (
          <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
            {(Array.isArray(users) ? users : []).slice(0, 100).map(u => (
              <div key={u.id} style={{ padding: '10px', marginBottom: '10px', border: '1px solid #ddd', borderRadius: '5px', backgroundColor: '#f9f9f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <strong>{u.full_name}</strong>
                  <span style={{ marginLeft: '10px', color: '#666', fontSize: '14px' }}>({u.email})</span>
                  {u.is_admin && <span style={{ marginLeft: '10px', padding: '2px 8px', backgroundColor: '#f44336', color: 'white', fontSize: '12px', borderRadius: '3px' }}>אדמין</span>}
                </div>
                {!u.is_admin && (
                  <button 
                    onClick={() => handleDeleteUser(u.id, u.full_name)}
                    style={{ padding: '5px 12px', backgroundColor: '#f44336', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
                  >
                    🗑️
                  </button>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      <div style={{ marginTop: '30px', textAlign: 'center' }}>
        <button 
          onClick={() => { setIsLoggedIn(false); setToken(''); setPassword(''); }}
          style={{ padding: '10px 20px', backgroundColor: '#666', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
        >
          התנתק
        </button>
      </div>
    </div>
  );
};

export default RoeyAdminPage;
